/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Agree_AndInputs */

const en_common_sign_agree_and = /** @type {(inputs: Common_Sign_Agree_AndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`and`)
};

/**
* | output |
* | --- |
* | "and" |
*
* @param {Common_Sign_Agree_AndInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_sign_agree_and = /** @type {((inputs?: Common_Sign_Agree_AndInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Agree_AndInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_sign_agree_and(inputs)
});
export { common_sign_agree_and as "common.sign.agree_and" }